import ActionTypes from './container/actionType'

const PlayReducers = (state = {
    playQuiz: '',
    playKey: '',
    currentQuiz: {},
    playingData: '',
  

}, action) => {
    switch (action.type) {
        case ActionTypes.PlayingQuiz: {
            return state = {
                ...state,
                playingData: action.payload
            }
        }
        case ActionTypes.PlayOptions: {
            return state = {
                ...state,
                playQuiz: action.payload
            }
        }
        case ActionTypes.PlayingKey: {
            return state = {
                ...state,
                playKey: action.payload
            }
        }
        case ActionTypes.SETCURRENTQUIZ: {
            return state = {
                ...state,
                currentQuiz: action.payload
            }
        }
        default: { }
    }
    return state;
}
export default PlayReducers;


// WEBPACK FOOTER //
// ./src/reducers/PlayReducers.jsx